(() => {
  if (customElements.get("slider-product-swatches")) {
    return;
  }

  class SliderProductSwatches extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        slidesPerView: this.getAttribute('data-slides-per-view') ?? 9,
        spaceBetween: 5,
        navigation: {
          prevEl: this.closest("[data-color-section]").querySelector(
            "[data-arrow-prev]"
          ),
          nextEl: this.closest("[data-color-section]").querySelector(
            "[data-arrow-next]"
          ),
        },
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define("slider-product-swatches", SliderProductSwatches);
})();
